/* global moment */
import { formatDisplayDateTimeFromStore } from './dateFormatters'

export const TRACEABILITY_CLOSING_DATE = '1970-01-01 00:00:00'

export const TRACEABILITY_DATE_FORMATS = [
    moment.ISO_8601,
    'YYYY-MM-DD HH:mm:ss',
    'YYYY-MM-DD HH:mm',
    'DD/MM/YYYY HH:mm:ss',
    'DD/MM/YYYY HH:mm',
    'DD/MM/YYYY'
]

export function parseTraceabilityMoment(value) {
    if (!value) {
        return null
    }

    const parsed = moment(value, TRACEABILITY_DATE_FORMATS, true)
    return parsed.isValid() ? parsed : null
}

/** Formatea la presentación sin modificar las fechas de la etiqueta ni su impresión. */
export function formatTraceabilityDate(value, locale) {
    const markedPrintDate = typeof value === 'string' && /\s+\*$/.test(value)
    const parsed = parseTraceabilityMoment(markedPrintDate ? value.replace(/\s+\*$/, '') : value)
    if (!parsed) return value
    return `${formatDisplayDateTimeFromStore(parsed, { locale })}${markedPrintDate ? ' *' : ''}`
}

export function isTraceabilityClosingDate(value) {
    const normalized = String(value || '').trim()

    return normalized === TRACEABILITY_CLOSING_DATE || (normalized !== '' && !parseTraceabilityMoment(normalized))
}

export function resolveTraceabilityExpirationMoment(label, parsedData = {}) {
    if (!label) {
        return null
    }

    const candidates = [label.end_date, label.caducidad_1a, parsedData.caducidad]
        .filter((value) => !isTraceabilityClosingDate(value))
        .map(parseTraceabilityMoment)
        .filter(Boolean)

    return candidates.reduce((earliest, candidate) => {
        return !earliest || candidate.isBefore(earliest) ? candidate : earliest
    }, null)
}

export function resolveTraceabilityExpirationState(label, serverNow, parsedData = {}) {
    const expirationMoment = resolveTraceabilityExpirationMoment(label, parsedData)
    const now = moment.isMoment(serverNow) ? serverNow : parseTraceabilityMoment(serverNow)

    if (!expirationMoment || !now) {
        return {
            expirationMoment,
            isExpired: false,
            isExpiresToday: false
        }
    }

    const isExpired = expirationMoment.isSameOrBefore(now)

    return {
        expirationMoment,
        isExpired,
        isExpiresToday: !isExpired && expirationMoment.isSame(now, 'day')
    }
}
